import { useMemo } from 'react';

import { useAppSelector } from '@/hooks/redux-helpers';
import { routeStore } from '@/store/configuration';
import { IAccessTokenDecoded } from '@/store/models/auth.model';
import useAdvancedRole from '@/features/roles/hooks/useAdvancedRole';
import { decode_token } from '@/features/dashboard-users/helpers/decode_token';
import { useDashboardUserInformation } from '@/features/dashboard-users/hooks/useDashboardUserInformation';

export const useCurrentSupportUser = () => {
  const config = useAppSelector((state) => state.dashboardConfig.config);
  const currentSupportUser = useAppSelector((state) => state.auth.currentSupportUser?.state);

  const { isBlocked, lastLogin, creationDate, hasSecureKey, transports, secureKeyCreatedDate } =
    useDashboardUserInformation(currentSupportUser);

  const isCurrentSupportUserLoading = useAppSelector((state) => state.auth.currentSupportUser?.isLoading);
  const shouldChangePassword = useAppSelector((state) => state.auth.currentSupportUser?.shouldChangePassword);
  const role = useAdvancedRole();
  const accessToken = useAppSelector((state) => state.auth.token?.access_token);
  const accessTokenDecoded = useMemo<IAccessTokenDecoded | undefined>(() => decode_token(accessToken), [accessToken]);
  const scopes = accessTokenDecoded?.scope;
  const has2FAEnabled = !!config?.settings?.['2fa'];
  const isAuthenticated = accessTokenDecoded ? accessTokenDecoded?.exp > Date.now() / 1000 : false;
  const hasPassphrase = !config?.api.encryption || !!routeStore.supportUserPassphrase;
  const isSSO = config?.api.sso.responseType === 'token';

  return {
    role,
    config,
    scopes,
    isAuthenticated,
    accessTokenDecoded,
    hasPassphrase,
    has2FAEnabled,
    isSSO,
    isCurrentSupportUserLoading,
    shouldChangePassword,
    isBlocked,
    lastLogin,
    creationDate,
    hasSecureKey,
    transports,
    secureKeyCreatedDate,
    ...currentSupportUser,
  };
};
